// Kurv-skuffe - design G (EuropeSnus)
// ------------------------------------
// To ting, som ingen af de eksisterende kurv-scripts daekker:
//
//  1. Tracking. Uden baseline kan vi ikke se om den nye kurv virker. Events
//     lander i window.dataLayer (GA4 via GTM). Triple Whale er IKKE koblet paa
//     endnu - se rapporten.
//  2. Upsell-raekken skal aldrig vise noget, der allerede ligger i kurven.
//     Den genhentes derfor, naar kurvens produkt-saet aendrer sig - ikke ved
//     hver maengdeaendring, som ville give et unoedigt kald og et blink.

(function () {

  var drawer = document.getElementById('site-cart-sidebar');
  if (!drawer) return;

  // --- tracking -------------------------------------------------------
  function dl(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    } catch (e) { /* tracking maa aldrig braekke kurven */ }
  }

  function snapshot() {
    var count = document.querySelector('#AjaxCartForm [data-cart-count]');
    var total = document.querySelector('#AjaxCartForm [data-cart-total]');
    return {
      viewport_width: window.innerWidth,
      item_count: count ? parseInt(count.textContent.trim(), 10) || 0 : 0,
      subtotal: total ? total.textContent.trim() : '',
      market: (document.documentElement.lang || '') + '|' + (drawer.dataset.market || '')
    };
  }

  var openedAt = null;
  function secondsOpen() {
    return openedAt === null ? null : Math.round((Date.now() - openedAt) / 1000);
  }

  // show()/hide() i section-header.js dispatcher ingen events, saa vi ser paa
  // klassen i stedet for at patche temaets egen komponent.
  var wasOpen = drawer.classList.contains('sidebar--opened');
  new MutationObserver(function () {
    var isOpen = drawer.classList.contains('sidebar--opened');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;
    if (isOpen) {
      openedAt = Date.now();
      dl('cart_drawer_open', snapshot());
    } else {
      dl('cart_drawer_close', { seconds_open: secondsOpen() });
      openedAt = null;
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  drawer.addEventListener('click', function (e) {
    var checkout = e.target.closest('#CheckOut');
    if (checkout) {
      dl('cart_drawer_checkout_click', Object.assign(snapshot(), { seconds_open: secondsOpen() }));
      return;
    }

    var upsell = e.target.closest('[data-js-upsell-add]');
    if (upsell) {
      dl('cart_drawer_upsell_add', {
        product: upsell.dataset.productTitle || '',
        position: parseInt(upsell.dataset.position, 10) || null
      });
      return;
    }

    var step = e.target.closest('.qty-plus, .qty-minus');
    if (step) {
      var item = step.closest('[data-js-cart-item]');
      if (!item) return;
      var from = parseInt(item.dataset.qty, 10) || 0;
      var to = step.classList.contains('qty-plus') ? from + 1 : Math.max(0, from - 1);
      dl('cart_drawer_qty_change', { from: from, to: to, product: item.dataset.title || '' });
    }
  });

  // --- faelles "kurven er aendret"-signal ------------------------------
  //
  // component-product-form.js (upsell-plusset) udskifter baade #AjaxCartForm og
  // #AjaxCartSubtotal, men dispatcher kun sit eget 'add-to-cart' paa selve
  // <product-form> - og det event har ikke bubbles:true. Resultatet var, at
  // alt der lytter paa 'cart:updated' gik glip af en tilfoejelse fra upsell:
  // footerens leveringslinje blev tom (dens <span> var netop blevet udskiftet),
  // upsell-raekken blev ved med at vise den vare der lige blev lagt i kurven,
  // og B2B-minimumsspaerringen genberegnede ikke.
  //
  // Et non-bubbling event passerer stadig CAPTURE-fasen fra document og ned,
  // saa en capture-lytter her fanger det uden at patche temaets komponent.
  document.addEventListener('add-to-cart', function () {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }, true);

  // --- upsell-raekken -------------------------------------------------
  function cartProductIds() {
    return Array.prototype.map
      .call(document.querySelectorAll('#AjaxCartForm [data-js-cart-item]'), function (el) {
        return el.dataset.productId;
      })
      .sort()
      .join(',');
  }

  var lastProductIds = cartProductIds();
  document.addEventListener('cart:updated', function () {
    var ids = cartProductIds();
    if (ids === lastProductIds) return;
    lastProductIds = ids;

    var rec = document.querySelector('cart-recommendations');
    if (rec && typeof rec.generateRecommendations === 'function') {
      // generateRecommendations skriver kun, naar der ER kort at vise. Ryd
      // foerst, ellers bliver gamle kort staaende naar alt er i kurven.
      rec.innerHTML = '';
      rec.generateRecommendations();
    }
  });

})();
